module.exports = {
  qqgdscpjypt: "Plataforma global de negociación de productos de agua a granel",
  qqgdscpjypt1:
    "Plataforma global de negociación de productos de agua a granel",
  qqgdscpjypt2:
    "(y plataforma mundial de comercio de productos acuáticos de gama alta)",
  zczh: "Registrar la cuenta",
  yzmdl: "Código de verificación",
  zhmmdl: "contraseña",
  sjh: "Celular",
  yzm: "Codigo de verificacion",
  yhylsjh: "Número de teléfono móvil reservado en el banco",
  qsrsjh: "Ingresar Numero de Celular",
  qsryzm: "Clave",
  hqyzm: "Acceso",
  qsrmm: "Ingresar el clave",
  dl: "Iniciar sesión",
  dlsb: "Error de clave",
  dlgqqcxdl: "Sesion caducada  / Reinicie",
  zc: "Registrar",
  zcsb: "Registro fallido ",
  yzmbnwk: "El codigo de verificacion debe ser llenado",
  hqyzmsb: "No se pudo obtener el codigo de verificacion",
  yzmfscg: "Codigo de verificacion enviado con exito",
  sjhbnwk: "Celular debe ser llenado",
  sjhgscw: "Numero de celular incorrecto",
  mmbnwk: "Clave debe ser llenado",
  mmtips:
    "La contraseña debe constar entre 8-14 letras, numeros y simbolos ( no debe ser solo numeros ) ",
  bottomcopyright1:
    "2023 Plataforma de comercio de productos acuáticos Certificado ICP: Beijing ICP No. 16005856",
  bottomcopyright2: "Beijing Public Network Security No. 11010802026156",
  ztsc: "Mercado temático",
  hello: "Hola",
  qrz: "Verificacion",
  rzhjkckjyxqy:
    "Después de la verificacion, puede ver la página de detalles de la transacción",
  qkh: "Registrar la cuenta",
  khhjkzptwcjy:
    "Después de abrir una cuenta, puede completar la transacción en la plataforma",
  khsbxycxkh: "La apertura de la cuenta falló, registra de nuevo",
  qyz: "Verificacion",
  dzhyz: "Verificación de cuenta ",
  rzqyykhqlxkf:
    "La empresa certificada y con cuenta aperturada, comuníquese con el servicio al cliente",
  zljyz: "Verificación de datos",
  shz: "en proceso de revisión",
  clz: "Procesando",
  dzqyz: "En proceso de firma electronica",
  jnrzbzj: "Pagar el deposito de garantia",
  jnrzbzjhkschy:
    "Después de pagar el depósito de garantia, puede cargar los productos",
  wyhyxzzycjj: "Tengo un suministro y quiero organizar una subasta.",
  wyhyxzjmc: "Tengo la fuente y quiero vender directamente",
  yrz: "Verificado",
  hyzx: "Noticias",
  gd: "Más",
  qb: "Total",
  zq: "área especial",
  kssj: "hora de apertura",
  ksz: "abierto",
  xsz: "Cerrado",
  xqyzxqldsj: "Lunes a Sábado (excepto festivos)",
  morning: "09:00-11:30 a. m.",
  zwsj: "9:00-16:30",
  jjmc: "oferta para vender",
  jjmr: "oferta para comprar",
  wyddxzzycjj: "Tengo un pedido y me gustaría organizar una subasta",
  gpmc: "Listado para vender",
  gpmr: "listado para comprar",
  wyddxsgyphy: "Tengo un pedido y quiero comprar un lote de productos",
  bhtjy: "Contiene ** transacciones",
  bh: "包含 ",
  jyy: "条交易",

  jjkp: "a punto de subasta",
  jjks: "A punto de comenzar",
  bmz: "registrarse",
  jxz: "en curso",
  yjs: "Finalizado ",
  lp: "no vendido",
  wbmd: "Me inscribí",
  zxsc: "Última subida",
  kpsj: "Hora de inicio",
  w: "Yo",
  wd: "Mio",
  jg: "Precio ",
  qpj: "Precio inicial",
  dqj: "precio actual",
  cjj: "precio final",
  yuan: "Yuan",
  zwxgxx: "¡Todavía no hay contenido relacionado！",

  ryd: "Leidos por ** personas ",
  qxdzcg: "Cancela como con éxito",

  bm: "Inscribir",
  xzkhjl: " nuevo registro de visualización",
  jbxx: "Información básica",
  hymc: "Nombre del producto",
  qsrhymc: "Por favor ingrese el nombre del producto",
  dw: "Unida",
  djtxdw: "Haga clic para llenar la unidad",
  tiao: "条",
  dun: "T",
  zl: "Peso",
  hydz: "Dirección de la mercancia",
  hyzp: "Foto de la mercancia",
  scp: "subir fotos",
  zdjz: "(Maximo 9 fotos)",
  bcqtxx: "otra información complementaria",
  bcbtj: "guardar y enviar",
  cjfdxdydqjg: "El rango de oferta debe ser mayor que el precio actual",
  fscgddmfqr:
    "Enviado con éxito, esperando confirmación por parte del vendedor",
  cjcg: "oferta exitosa",
  cjsb: "oferta fallida",

  sy: "Página delantera",
  rz: "Verificado ",
  grrz: "Verificacion  de persona natural ",
  gsrz: "Verificacion de empresa",
  sczj: "subir documentos",
  xm: "Nombre y Apellido",
  qsrxmxysfzbcyz:
    "Ingrese su nombre y apellido que debe ser lo mismo de su documento de identidad",
  ztlx: "Especie principal",
  djxzlx: "Haga clic para seleccionar la especie",
  jysx: "Atributos comerciales",
  djxzsx: "Click para seleccionar propiedades",
  jydz: "Dirección de Negocios",
  djxzdz: "Haga clic para seleccionar la dirección",
  xxdz: "DIRECCIÓN",
  qsrxxdz: "Por favor ingrese la dirección detallada",
  jypx: "artículos de negocios",

  djxzpx: "Haga clic para seleccionar el articulo ",
  gsmc: "Nombre de la empresa",
  qsrgsmcxyyyzzyz:
    "Ingrese el nombre de la empresa, que debe ser lo mismo con el nombre de la licencia comercial",
  qsrgsmc: "Por favor, introduzca el nombre de empresa",
  lxr: "Contacto",
  qsrlxr: "Por favor ingrese un contacto",
  qscsfz: "Por favor adjunta el documento de la identidad",
  qscsfzwssfxx:
    "Adjuntar su documento de identificación para completar su información de identidad",
  qpsbscndyyzz: "Tome una foto y cargue su licencia comercial",
  djscsfzzm: "Haga clic para adjuntar el frente de su documento de identidad",
  djscsfzbm: "Haga clic para adjuntar el reverso de su documento de indentidad",
  djscyyzz: "Haga clic para cargar la licencia comercial",
  tj: "Enviar",
  tjrz: "Enviar la verificacion ",
  thcg: "Enviado satisfactoriamente",
  tjsb: "Envío fallido",
  yqm: "Código de invitación",
  yqmxt: "Código de invitación (opcional)",
  qtxyqm: "Por favor complete el código de invitación",
  sryqmrwkbt: "Introduzca el código de invitación, si es necesario",
  qd: "Seguro",
  qx: "Cancelar",
  sctpyc: "Fotos adjuntados  anormales",
  sfzxmysrxmbyzqcxtr:
    "El nombre y apellido ingresado no coince con su documento de identidad , por favor complete nuevamente～",
  yyzzmcysrmcbtzqcxtx:
    "El nombre de empresa ingresado no coincede con la licencia comercial, vuelva a completarlo～",
  tpsbycqcxsc:
    "El reconocimiento de la imagen es anormal, verifique la información de la imagen cargada",
  rzsb: "Autenticación fallida",
  rzyc: "excepción de autenticación",
  qsryqm: "Por favor, introduzca el código de invitación",

  grzx: "centro personal",
  zhye: "Saldo de la cuenta",
  wdye: "mi balance",
  ljczlc: "Conocer el proceso de recarga",
  tx: "retirar",
  bccg: "Guardado exitosamente",
  bcsb: "Error al guardar",
  bcyhcw: "guardar error de usuario",
  txtp: "foto de avatar",
  bdsjh: "Vincular número de teléfono móvil",
  hb: "cambio de numero",
  dlmm: "contraseña de inicio de sesión",
  qsz: "ir a la configuración",
  xgmm: "cambiar la contraseña",
  szmm: "configurar la clave",
  qr: "confirmar",
  djscndtx: "Haz clic para subir tu avatar",
  hbsjh: "cambiar número de teléfono",
  qsrhbsjh: "Por favor, introduzca su número de teléfono móvil",
  dqsjh: "número de teléfono actual",
  ghcg: "Reemplazado con éxito",
  xgcg: "Modificado con éxito",
  szcg: "establecido con éxito",
  uploatips: "El tamaño del archivo de carga no puede exceder los 5 MB",
  success: "éxito",
  fail: "fallar",

  zhmx: "Detalles de la cuenta",
  mj: "vendedor",
  maij: "comprador",
  dj: "congelar",
  djmx: "Detalles de fondo congelado",
  yjcdj: "descongelado",
  zrtxje: "Detalle de retiro ",
  pfmx: "Detalles del pago",

  rzbzj: "Depósito de entrada",
  bzjtips:
    "Si el vendedor inicia una transacción, el depósito de liquidación no debe ser inferior a 100.000 yuanes.",
  bzjtips1:
    "En la etapa de operación de prueba, esta regulación no se implementará por el momento.",
  zcdz: "trasferencia",
  zrdz: "transferencia",

  qrcj: "confirmar oferta",
  hpmc: "nombre del producto",
  zxjg: "Último precio",
  ykj: "Compre ya",
  jpcj: "oferta de subasta",
  cjf: "licitador",
  dunshu: "Toneladas",
  zdbmds: "Tonelaje mínimo de registro",
  grds: "Toneladas compradas",
  cjje: "monto de la oferta",
  qsrndgrds: "Por favor ingrese el tonelaje de su compra",
  qsrndcjje: "Ingrese el monto de su oferta",

  wddd: "Mi pedido",
  hyd: "Fuente",
  shd: "Recibo",
  djkckmfhy: "Haga clic para ver el suministro del vendedor",
  hyzj: "Precio total del suministro",
  djtips:
    "Depósito (la fianza de ejecución congelada compensa el pago de los bienes)",
  fwf: "cargo por servicio",
  wk: "pago final",
  ddbh: "número de orden",
  copy: "Copiar",
  cjsj: "tiempo de creación",
  mffk: "el comprador paga",
  ccbg: "informe de fábrica",
  zskf: "Atención al cliente exclusiva",
  hckf: "Atención al cliente Huacai",
  dfpkf: "Para ser asignado control de calidad...",
  lxpk: "Comuníquese con el control de calidad",
  qfk: "pagar",

  txmfhy: "Rellene el suministro del vendedor",
  ckmfhy: "Ver el suministro del vendedor",
  hyxx: "Información de origen",
  ddxx: "información del pedido",
  ksrbcne: "Se puede ingresar contenido adicional....",
  bt: "requerido",
  xt: "opcional",
  fsgmf: "enviar al comprador",

  sztx: "establecer recordatorio",
  sztxcg: "Recordatorio establecido con éxito",
  qxtxcg: "Recordatorio cancelado con éxito",
  szsb: "La configuración falló",
  qxbmcg: "Cancelación exitosa de registro",
  ysz: "Ha sido establecido",
  jjs: "desde el final",
  jks: "desde el principio",
  sc: "duración",
  kdjckkhjl: "Puede hacer clic para ver los registros de visualización",
  bm10sr: "Regístrate para ** personas",
  wg10ren: "Ver ** veces",
  jybh: "número de transacción",
  jplx: "tipo de subasta",
  jjfd: "Margen",
  jjfdjj: "grado de disminución",
  jpsj: "tiempo de subasta",
  jpsc: "Duración de la subasta",
  fz: "minuto",
  yszq: "Período de retraso",
  jylx: "tipo de transacción",
  scsj: "Tiempo de carga",
  lxdh: "número de contacto",
  ppxq: "Detalles del lote",
  pkbb: "Informe de control de calidad",
  cjjl: "registro de oferta",
  xqms: "Descripción del requisito",
  hyms: "Descripción de la fuente",
  jjr: "licitador",
  sj: "tiempo",
  ckgd: "ver más",
  zwcjjl: "Aún no hay registro de ofertas",
  smewmdsj: "Escanea el código QR al teléfono móvil",
  dqrp: "Éxitos actuales",
  yhwrzqdgezxrz:
    "El usuario no está autenticado, diríjase al centro personal para la autenticación",

  ckkhxx: "Ver información de la vista",
  lsjl: "registro de la historia",
  bmcg: "Regístrese con éxito",
  dmfqr: "A confirmar por el comprador",
  mfjj: "El comprador se niega",
  mfcswcl: "Se agotó el tiempo de espera del comprador",
  bj: "editar",
  delete: "borrar",
  qrxgfsgmf: "Confirmar revisión enviada al comprador",
  qrscgkhxx: "¿Estás seguro de eliminar la información de visualización?",
  sccg: "eliminado con éxito",
  ldfs: "método de congelación",
  jjsz: "configuración de ofertas",
  jjrq: "fecha de oferta",
  djxzjjrq: "Haga clic para seleccionar la fecha de la oferta",
  jjsj: "tiempo de oferta",
  djxzjjsj: "Haga clic para seleccionar el tiempo de oferta",
  jjsc: "tiempo de oferta",
  djxxjjsc: "Haga clic para seleccionar el tiempo de oferta",
  srsz: "escriba los datos",
  gpsz: "configuración de listado",
  jgsz: "configuraciones de entrega",
  yf: "transporte",
  djlybzj: "Congelar la fianza de cumplimiento",
  tjhddsh: "Esperando revisión después del envío",

  bmlb: "lista de registro",
  dqr: "para ser confirmado",
  yjj: "rechazado",
  yqr: "confirmado",
  bmbh: "número de registro",
  bmsj: "tiempo de registro",
  sfjjbm: "¿Te niegas a aplicar?",

  syrzbzjy: "Depósito de liquidación restante (yuan)",
  rzbzjtips1:
    "Si el cliente del vendedor inicia una transacción, el depósito de liquidación no debe ser inferior a 100.000 yuanes.",
  zrje: "Monto de la transferencia",
  qsrzrje: "Ingrese el monto de la transferencia",
  qbzr: "transferir todo en",
  yczr: "transferir desde aquí",
  zrcg: "transferencia exitosa",
  zrsb: "Error al transferir",

  zcje: "monto de la transferencia",
  qsrzcje: "Ingrese el monto de la transferencia",
  qbzc: "transferir todo",
  zcz: "transferir a",
  zccg1: "transferir con éxito",
  zcsb1: "No se pudo transferir",

  ktzfzh: "Abrir cuenta de pago",
  grkh: "Apertura de cuenta personal",
  qykh: "apertura de cuenta comercial",
  gtgshkh: "Apertura de cuenta comercial individual",
  khsb: "Apertura de cuenta fallida",
  wdyhk: "mi tarjeta bancaria",
  yjhb: "Cambio con un clic",
  bdyhk: "Vincular tarjeta bancaria",
  zhlx: "Tipo de cuenta",
  qdjxz: "Por favor haga clic para seleccionar",
  dgzh: "público",
  dszh: "privado",
  ckr: "titular de la tarjeta",
  qsrckrxm: "Ingrese el nombre del titular de la tarjeta",
  qsrxm: "Por favor escriba su nombre",
  yhkh: "número de tarjeta bancaria",
  qsrkh: "Por favor ingrese el número de tarjeta",
  khh: "banco",
  qsrkhh: "Por favor ingrese al banco",
  zcyh: "banco de apoyo",

  wfbd: "publiqué",
  wdjy: "mi trato",
  wgzd: "Me preocupa",
  qtgn: "Otras funciones",

  yx: "Correo",
  dz: "DIRECCIÓN",
  kfzsewm: "Código QR exclusivo para atención al cliente",
  qtxzgcyhdwzs:
    "Ingrese el monto que Zhongguancun Bank transfiere a esta cuenta corporativa",
  skjey: "Importe del recibo (yuan)",
  ytjqnxddsh: "Enviado, espere pacientemente para la revisión.",

  yey: "saldo (yuan)",
  txje: "Cantidad de retiro",
  qsrtxje: "Ingrese el monto del retiro",
  qbtx: "retirar todo",
  dzyhk: "tarjeta bancaria",

  jjcj: "ofertas",
  ydzdcj: "Se ha alcanzado la puja mínima",
  zklyx: "piensa otra vez",
  jjcg: "Oferta exitosa",
  jyts: "consejos comerciales",
  qrybdyhk: "Confirmar que la tarjeta bancaria ha sido vinculada",
  syysyhkxrxzhhk:
    "Use la tarjeta bancaria anterior para transferir dinero a la siguiente cuenta",
  zhm: "nombre de la cuenta",
  zhzh: "cuenta",
  zhc: "zhang huacai",
  bjyhzgczh: "Beijing Zhongguancun Bank Co., Ltd.",
  xzf: "Necesito pagar",
  wkyf: "Pago final por pagar",
  xzzffs: "Seleccionar método de pago",
  wdzh: "mi cuenta",
  qrzf: "confirmar pago",
  zhyebzljzr: "Saldo de cuenta insuficiente, entender la transferencia",
  zfcg: "Pago exitoso",
  bmxz: "Aviso de registro",
  dqbdlybzj: "Bono de cumplimiento objetivo actual",
  ndzhye: "el saldo de tu cuenta",
  bmjjjbstyxydjbzj:
    "Inscribirse en la licitación significa aceptar congelar la garantía de cumplimiento correspondiente",
  rwhpjth:
    "De lo contrario, la fianza de cumplimiento congelada se descongelará automáticamente.",
  rcgzcdhk:
    "Si la subasta tiene éxito, la fianza de cumplimiento congelada se utilizará como depósito para compensar el pago cuando pague el saldo",
  rcgpxjkc:
    "Si no cumple con el contrato después de ofertar con éxito, se deducirá el depósito de seguridad congelado",
  zhyebzwfbm: "Saldo de cuenta insuficiente, no se puede registrar",
  qzr: "transferir en",
  qrbm: "Confirmar registro",

  zd: "ir a",
  ye: "Página",

  scxgzj: "Subir documentos relevantes",
  qscyyzz: "Cargue la licencia comercial",
  yyqx: "Período de funcionamiento",
  qsryyqx: "Por favor ingrese el período comercial",
  zcdz1: "Dirección registrada",
  qsrzcdz: "Por favor ingrese la dirección registrada",
  tyshxydm: "Código de Crédito Social Unificado",
  qsrtyshxydm: "Por favor ingrese el código de crédito social unificado",
  qsczzjgdmz: "Cargue el certificado del código de la organización",
  djsczzjgdmz:
    "Haga clic para cargar el certificado del código de la organización",
  zzjgdm: "Código de organización",
  qsrzzjgdm: "Por favor ingrese el código de la organización",
  zzjgdmzqx: "Período de certificado de código de organización",
  qsrzzjgdmzqx: "Ingrese el período del certificado de código de organización",
  qscswdjz: "Cargue el certificado de registro fiscal",
  djscswdjz: "Haga clic para cargar el certificado de registro fiscal",
  swdjzdm: "Código del certificado de registro fiscal",
  qscfrsfz: "Cargue el documento de identidad de la persona jurídica",
  sfzh: "número de identificación",
  qsrsfzh: "Por favor ingrese número de identificación",
  sfzyxq: "Período de validez de la tarjeta de identificación",
  qsryxq: "Por favor, introduzca una fecha de caducidad",
  qsclxrsfz: "Cargue la identificación de contacto",
  lxrxm: "Nombre de contacto",
  lxrsfzh: "Número de identificación de contacto",
  lxrsjh: "Teléfono de contacto",
  qsrlxrsjh: "Por favor, introduzca el número de teléfono de contacto",
  lxryx: "Email de contacto",
  qsrlxryx: "Por favor, introduzca el correo electrónico de contacto",
  zhmc: "nombre de la cuenta",
  qsrzhmc: "Por favor ingrese el nombre de la cuenta",

  wdfb: "Mis lanzamientos",
  tcdl: "Salir del login",
  smjrxcx: "Escanear en el applet",
  czgjfbkj: "Operación más conveniente y rápida",
  ss: "búsqueda",
  tgsh: "Pasó la auditoría",
  js: "final",
  bohui: "denegada",
  scdd: "generar",
  xgjg: "Cambio de precio",
  qdgj: "Cambio definitivo de precio",
  xjhyyy: "El avión",
  bmhy: "Fuente de inscripción",
  ckdd: "Ver el pedido",
  pkdh: "Teléfono de control de calidad",
  bmdjj: "Ofertas para inscribirse",
  bmdgp: "Listado de inscritos",
  dzdwz: "Artículos con likes",
  mairu: "compra",
  maichu: "venta",
  grxx: "Información personal",
  grsy: "Página inicial personal",
  quhao: "código",
  dfk: "Pendiente de pago",
  djg: "Pendiente de cierre",
  ywc: "Ya terminado",
  qt: "otros",
  dsh: "Pendiente de revisión",
  zsz: "En exhibición",
  nhqdl: "Hola por favor iniciar sesión",
  mfzc: "Regístrate gratis con",

  jyzx: "Transacciones",
  hyzx11: "Noticias",
  qgsj: "Nacional",
  qqsj: "Globales",
  cczx: "Servicios",
  gzzx: "Reglas",
  lxwm: "Contacta",
  sjzx: "Precio",
  grzxxx: "Personal",

  szgjjqyjyzx: "Centro internacional de comercio de atún de shenzhen",
  qqgdscpjyzx: "Plataforma global de negociación de productos de agua a granel",
  djjrjyzx: "Haga clic para acceder al trading central",
  gjst: "Co-construyendo ecología",
  hzgyy: "Cooperación y ganar",
  gongsijieshao: "Presentación de empresa",
  pingtaijieshao: "Presentación de la plataforma",
  dazaoqqzddyyjypt:
    "Crear un centro global de comercio en línea de productos acuáticos de alta gama",
  gsjstips111:
    "Una iniciativa de sinowater ocean corporation, una subsidiaria del grupo de desarrollo agrícola de China, con el apoyo técnico y profesional de huatchai technology (beijing) co., LTD.",
  lliaojiexiangq: "Conozca los detalles",
  guankanship: "Ver el video",
  xianshangjiaxianxia: "En línea + fuera de línea",
  gsjstips222:
    "La compañía se dedica a crear un centro de comercio en línea de productos acuáticos de gama alta global, impulsado por dos motores ‘en línea‘ + ’fuera de línea‘, vincular los productos acuáticos de gama alta fuera de la ciudad a través del centro de comercio digital remoto con el comercio de subasta en vivo.",
  sjzgrdbzsrjg:
    "Actualización de la estructura de ingesta de proteínas en China",
  gsjstips333:
    "Los productos acuáticos de alta gama pueden ser utilizados para el comercio de productos acuáticos de alta gama en todo el mundo, para mejorar la eficiencia de la circulación de comercio de productos acuáticos de alta gama en todo el mundo, para actualizar la estructura de la ingesta de proteínas de los chinos, y para reconstruir la nueva ecología digital de productos acuáticos de alta gama en todo el mundo.",
  gaoduanshuichanpzonghefuwupingtai:
    "Plataforma de servicios industriales integrales para productos acuáticos de alta gama",
  gsjstips444:
    "Aprobado por el gobierno de shenzhen, patrocinado conjuntamente por China agricultural development group y shenzhen port group, con el apoyo técnico de beijing huachai. Como base nacional de pesca pelágica de shenzhen proyecto piloto puesto en operación. El centro se lanzó oficialmente el 12 de mayo de 2023, es principalmente el comercio al por menor de productos acuáticos de gama alta, integrando el desarrollo de estándares de productos acuáticos, la investigación y la promoción de nuevas variedades, servicios de información de mercado, servicios técnicos, servicios financieros y servicios logísticos como un centro de servicios industriales integrados de productos acuáticos de gama alta.",
  pingtai1:
    "Cobertura en las principales ciudades de comercio de atún del mundo",
  pingtai2:
    "El centro se basa en shenzhen como centro, enlaza dalian, yantai, zhoushan, tokio, kaohsiung, bangkok y otras ciudades importantes de distribución de atún en todo el mundo, y establece un almacén de cierre para lograr el cierre global; Además del atún, el centro también cubre especies de productos acuáticos de alta gama, como bacalao plateado, salmón, cangrejo imperial y langosta.",
  pingtai3:
    "Internacionalización, estandarización, informatización y digitalización de transacciones",
  pingtai4:
    "El centro asume la gran responsabilidad de promover la innovación y la actualización de la industria mundial de productos acuáticos de alta gama y realizar la internacionalización, estandarización, informatización y digitalización del comercio de productos acuáticos; El centro utilizará su sólida capacidad operativa orientada al mercado, su capacidad de integración de recursos y sus recursos de apoyo de políticas preferentes para construir gradualmente un centro internacional de comercio, liquidación y fijación de precios de productos acuáticos de alta gama en la región de asia-pacífico.",
  adv1: "Ventajas de nosotros",
  adv2:
    "Comercio en la nube _ cierre global _ recursos exclusivos _ precios de shenzhen",
  adv3: "Gama alta",
  adv4: "Eficiente",
  adv5: "Alta calidad",
  adv7: "Alta calidad",
  adv6:
    "Crear un centro de comercio acuático de alta gama, centro de liquidación y centro de precios en la región asia-pacífico",
  cloud1: "Comercio en la nube",
  cloud2: "Cierre global",
  cloud3: "Recursos exclusivos para",
  cloud4: "Precio en shenzhen",
  cloud5: "Trazabilidad total",
  cloud6: "Inspección de calidad AI",
  cloud7: "Motor de datos",
  cloudIntro1:
    "Comercio en la nube. Compre y venda todo el mundo con un solo clic. Comercio con toques ilimitados",
  cloudIntro2:
    "Cierre global, cierre local en las principales ciudades de distribución del mundo, reduciendo los costos logísticos",
  cloudIntro3:
    "Recursos exclusivos, cuota total de capturas de atún rojo pelágico, canales de comercialización designados",
  cloudIntro4:
    "Shenzhen price lanza los precios reales de las ciudades de los centros mundiales de distribución de atún, ayudando al mercado chino a establecer el centro de precios",
  cloudIntro5:
    "Trazabilidad del producto durante todo el proceso, restauración de la verdadera información del producto, pescado por talla, para lograr un 100% de seguridad alimentaria",
  cloudIntro6:
    "El reconocimiento de imagen AI refuerza la capacidad de control de calidad, reduce el error de inspección tradicional de peces a través de estándares de inspección unificados y mejora la eficiencia de aplicaciones de múltiples escenarios",
  cloudIntro7:
    "Data engine para mejorar la precisión en la toma de decisiones a través de la minería de big data",
  gsdzzzzz:
    "Dirección de la compañía: 601A, bloque E1, parque de la sede de huatengshi, tribunal no.9, chenjiaylin, bailizhuang, distrito de chaoyang, beijing",
  xcxxxx: "Programa pequeño",
  fwhhhh: "Número de servicio",
  wzdhhh: "Navegación del sitio",
  pzzx: "Entrega",
  login1: "Crear cooperación ecológica y ganar-ganar",
  login9:
    "Promover el proceso de digitalización de productos acuáticos de alta gama con la Ciencia y la tecnología",
  login11: "Iniciar sesión ahora",

  person1: "Página inicial personal",
  person2: "Información personal",
  person7: "Proceso de apertura de cuenta",
  qkk: "mira",
  wfbdjy: "Mis ofertas publicadas",
  rxtel: "La línea",
  kfrxxx: "La línea",
  gzsjjj: "Horas de trabajo",
  jqy: "Atún",
  qtpl: "Otras categorías categorías",
  cjjjj: "El '",
  qpppp: "QiPai",
  plll: "PinLei",
  pxxx: "De",
  jqyfl: "Clasificación del atún",
  zzjx: "En curso",
  jssj: "Hora de fin",
  ysztx: "Se han establecido recordatorios",
  dpsjgzg: "La pantalla grande",
  cdxx: "Información de origen",
  ggzbjdx: "Especificación proporción y tamaño",
  hours: "Cuando",
  minus: "Las",
  second: "Segundos",
  wxsys: "Wechat barrido",
  service1: "Qué servicios tenemos",
  service2:
    "Haz crecer tu negocio con la potenciación total de nuestros servicios",
  service3: "Servicios financieros",
  service4:
    "Diseñado para proporcionar una gama completa de apoyo financiero a los clientes de arriba y abajo, ayudándoles a resolver problemas de rotación de capital, mejorar la eficiencia de las transacciones y reducir los costos de transacción",
  service5: "Integral",
  service6: "Servicios de logística",
  service7:
    "Diseñado para proporcionar un soporte logístico eficiente y conveniente a los clientes de arriba y abajo, ayudándoles a completar mejor las transacciones y la distribución logística",
  service8: "Eficiente.",
  service9: "Servicios de datos",
  service10:
    "Diseñado para proporcionar a los clientes ascendentes y descendentes datos comerciales completos, oportunos y precisos e información de mercado para ayudarles a entender las dinámicas y tendencias del mercado y tomar decisiones comerciales más informadas",
  service11: "Profesional",
  service12: "Una visión completa",
  service13:
    "Incluye UN servicio de financiación de los servicios de gestión de riesgos, etc., para la que ofrecen a los clientes de apoyo financiero, para ayudarles a resolver el problema de liquidez, la eficiencia de transacciones, reducir los costos de transacción, el centro también planea ampliar aún más los servicios financieros, incluida la creación de productos financieros innovadores, como el centro para la de ofrecer a los clientes más integral y profesional de los servicios financieros.",
  service14:
    "Incluye servicio de almacenamiento, servicio de distribución, servicio de declaración de aduanas, servicio de seguros, etc., diseñado para proporcionar a los clientes de arriba y abajo un apoyo logístico eficiente y conveniente para ayudarles a completar mejor la transacción y la entrega logística. El centro también tiene previsto ampliar aún más sus servicios logísticos, incluyendo el establecimiento de una plataforma de información logística y el desarrollo de herramientas SAAS para la gestión de la logística, con el fin de proporcionar un apoyo logístico más completo y eficiente a los clientes en fases anteriores y posteriores.",
  service15:
    "Incluye datos de cotas en tiempo real, análisis de datos comerciales, publicación de información de mercado y servicios de personalización de datos. Está diseñado para proporcionar a los clientes anteriores y posteriores datos comerciales completos, oportunos y precisos e información de mercado para ayudarles a comprender la dinámica del mercado y las tendencias y tomar decisiones comerciales más informadas. El centro también planea ampliar aún más los servicios de datos, incluyendo el establecimiento de un centro de datos, el desarrollo de software de análisis de datos, etc., para proporcionar un soporte de datos más completo y profesional a los clientes de arriba y abajo.",
  slx: "Cantidad (caja)",
  cdmc: "Denominación de origen",
  rknf: "Año de almacenamiento",
  rkyf: "Mes de almacenamiento",
  ggzbjdxplace:
    "Por favor, escriba la proporción y el tamaño de las especificaciones incluidas en la fuente, por ejemplo: especificación 100-150 25%, es más grande; Especificación 200-3000 proporción 75%, tamaño normal",
  rules1:
    "Resumen de las reglas de la plataforma global de negociación de productos de agua a granel (prueba)",
  rules2: "Capítulo I. disposiciones generales",
  rules3: "Artículo 1",
  rules4:
    "Normas para las plataformas de transacciones de la acuicultura mundial de las transacciones en línea (en adelante esta plataforma), el mantenimiento del orden en el mercado, garantizar los derechos legales, según el código civil de la república popular China, la república popular China PaiMaiFa, las especificaciones de los servicios del centro de transacciones de comercio electrónico de terceros como leyes y reglamentos, etc., para el presente reglamento.",
  rules5: "Artículo 2",
  rules6:
    "Estas reglas se aplican a la actividad de negociación en la plataforma global de negociación de productos de agua a granel. Todo el personal de trading central, miembros, creadores de mercado, depósitos de entrega y organizaciones asociadas asociadas deben cumplir con estas reglas.",
  rules7: "Capítulo 2 operaciones",
  rules8: "Artículo 3 hora de apertura",
  rules9: "1. De lunes a sábado: 9:00-16:30 todos los días;",
  rules10: "2.Cerrado los domingos y festivos",
  rules11: "Artículo 4 tarifas",
  rules12:
    "Los compradores y vendedores deben pagar diferentes tarifas de acuerdo con diferentes métodos y categorías de transacciones. Por favor, consulte las tarifas de la plataforma para más detalles",
  rules13: "papel",
  rules14: "El comprador",
  rules15: "El vendedor",
  rules16: "Iniciar un modelo de trading",
  rules17: "Reglas de trading",
  rules18:
    "El comprador sube la demanda de compra y establece un precio inicial. El vendedor puja de acuerdo con la demanda del comprador. El precio más bajo recibe.",
  rules19:
    "El comprador sube la demanda de compra, establece el precio y la cantidad y otros umbrales, y el vendedor vende de acuerdo con la demanda del comprador.",
  rules20:
    "El vendedor sube y vende las mercancías y establece un precio inicial. El comprador puja de acuerdo a la demanda del vendedor. El precio más alto recibe.",
  rules201:
    "El vendedor sube los detalles de la fuente de venta y establece un precio inicial. Los compradores pujan de acuerdo a la demanda del vendedor. El precio más alto recibe.",
  rules21:
    "El vendedor sube los detalles de las mercancías, establece el precio y la cantidad y otros umbrales, el comprador compra de acuerdo con la situación de las mercancías del vendedor.",
  rules22: "Tarifas del centro",
  rules23: "(provisional)",
  rules24:
    "Los compradores que participan en el comercio cobran el cargo de servicio 100 RMB/ton",
  rules25:
    "Los vendedores que participan en la transacción cobran una comisión de transacción de 5‰",
  rules26: "depósito",
  rules27:
    "Depósito comercial: el comprador debe pagar el depósito comercial del 20% del pago como depósito. Después de la transacción, este depósito será",
  rules28: "Depósito del comerciante en el centro 100000 RMB",
  rules29: "Pago y tiempo de entrega",
  rules30: "Pago final dentro de las 24 horas después de la orden",
  rules31: "(en caso de retraso, comuníquese con el centro)",
  rules32: "Envío dentro de 48 horas después del pago completo del comprador",
  rules33: "Artículo 5",
  rules34:
    "La moneda de cotización es RMB y la unidad de cotización es: se establece específicamente de acuerdo con los requisitos de la categoría.",
  rules35: "Artículo 6",
  rules36:
    "Todos los usuarios pueden actuar como compradores y vendedores en esta plataforma de negociación después de realizar un depósito completo y participar normalmente en la publicación de una venta/compra o inscripción/oferta.",
  rules37: "Artículo 7 margen comercial",
  rules38:
    "Los compradores y vendedores deben pagar el depósito comercial correspondiente de acuerdo con los requisitos del centro de comercio. Después de una transacción exitosa, el depósito será anulado.",
  rules39: "Artículo 8 devolución del depósito",
  rules40:
    "Si es elegible para un reembolso, generalmente se devolverá la cuenta de pago en la ruta original de 2 días hábiles.",
  rules41: "Artículo 9 retención de depósito",
  rules42:
    "Si la fuente publicada por el vendedor se puja con éxito en cualquiera de los siguientes casos, se deducirá una fianza equivalente al valor de la transacción o, si la fianza es insuficiente, se deducirá el pago completo:",
  rules43:
    "1. La calidad de la fuente entregada no corresponde a la descripción;",
  rules44:
    "2. No cumplir con el tiempo y los procedimientos especificados, para completar el procesamiento de la entrega de las mercancías;",
  rules45: "3. Incumplimiento del contrato al precio anunciado en la subasta.",
  rules46:
    "4. El centro retendrá una fianza equivalente al valor del volumen de negocios. Si la fianza es insuficiente, se deducirá el monto total pagado.",
  rules47:
    "Si la oferta de un comprador es exitosa y implica cualquiera de las siguientes circunstancias, se aplicará una retención de un depósito equivalente al valor de la transacción o, si el depósito es insuficiente, se deducirá el pago completo:",
  rules48:
    "1. No cumplir con el tiempo y los procedimientos especificados, completar el procesamiento de la entrega de las mercancías;",
  rules49: "2. No ejecutar el contrato al precio anunciado en la subasta.",
  rules50:
    "3. El centro retendrá un depósito equivalente al volumen de negocios. Si el depósito es insuficiente, se deducirá",
  rules51: "Artículo 10 penalización de depósito faltante",
  rules52:
    "1. Si la oferta es exitosa, pero el comprador no completa el pago a tiempo 1 día natural después del cierre de la oferta (el período de pago de la transacción) y la transacción no es compatible con la reanudación negociada de la transacción, el depósito pagado por el comprador será eliminado y pagado al vendedor una vez finalizado el período de pago de la transacción.",
  rules53:
    "2. La oferta fue exitosa, pero el comprador no completó el pago a tiempo dentro de los 2 días naturales posteriores al cierre de la oferta (el período de pago de la transacción), y la orden no se solicitó para reanudar la transacción durante el período negociado de reanudación de la transacción. El depósito pagado por el comprador se perderá y pagará al vendedor después del final del período de reanudación.",
  rules54:
    "3. La oferta fue exitosa, pero el comprador no completó el pago en el plazo de 1 día natural después del cierre de la oferta (el período de pago de la transacción), y el pedido fue solicitado para la recuperación pero no fue procesado por el vendedor o se le negó la reanudación de la transacción durante el período de negociación de la reanudación, y el depósito pagado por el comprador fue tomado y pagado al vendedor después de que se negó la reanudación de la transacción.",
  rules55:
    "4.Si el vendedor que ha pagado la fianza no entrega el lote al comprador de acuerdo con el contrato después de cerrar la venta, la fianza pagada por el vendedor se perderá y se pagará al comprador.",
  rules56:
    "Artículo 11 deducción de la tarifa de servicio de la fianza de confiscación",
  rules57:
    "1.En caso de que el comprador no haya pagado el depósito de garantía al vendedor debido a un incumplimiento o irregularidad por parte del comprador, el servicio no será reembolsado y tendrá derecho a una deducción directa en caso de pérdida del depósito de garantía.",
  rules58:
    "2.si la fianza pagada por el vendedor es multada al comprador por incumplimiento de contrato o infracción del vendedor, se deducirá la fianza de entrada correspondiente de acuerdo con la situación real.",
  rules59:
    "3.Situación especial: para la devolución del depósito o la retención de usted tiene cualquier objeción, puede apelar a través de la plataforma, la plataforma como parte intermedia, la coordinación justa de la compra, el vendedor para determinar la responsabilidad si devolver el depósito o hacer el procesamiento de retención correspondiente.",
  rules60: "Artículo 12",
  rules61:
    "La información cargada debe incluir, pero no limitarse a: tipo, especificación de la categoría, tonelaje, tiempo de almacenamiento, método de pesca, método de congelación, zona marítima de pesca, método de venta, fuente, foto de la fuente, descripción de la fuente, etc.",
  rules62:
    "Descripción de la fuente: nombre, tamaño de peso, grado, salvaje / cría, forma de la fuente (barra original / corte), especificaciones, método de congelación, Estado del embalaje, punto de fijación de peso y peso excesivo y otra información complementaria. ",
  rules621:
    "Descripción del pedido: categoría, precio, lugar de envío, información de la factura, etc.",

  rules63: "Artículo 13 métodos de transacción y sugerencias de selección",
  rules64:
    "1.Los usuarios pueden optar por iniciar sesión en la plataforma para pujar y listar.",
  rules65:
    "2.Tiempo de espera: durante 1 minuto de la cuenta regresiva antes del final de la puja, si alguien hace una oferta, la subasta se retrasa automáticamente en 3 minutos sobre esa base de tiempo de puja, y así sucesivamente hasta que nadie más puja 1 minuto antes del final de la cuenta regresiva y la puja se cierra",
  rules66: "Precauciones",
  rules67:
    "Preste atención a establecer un umbral para el número de compras para evitar licitaciones maliciosas. Ejemplo: competencia de bajo precio de una tonelada de mercancías.",
  rules68:
    "Comprender la tendencia de los precios de mercado y garantizar que las transacciones se desarrollen sin problemas.",
  rules69:
    "Los detalles de la fuente se registran claramente para asegurar la calidad del comercio.",
  rules70:
    "Los detalles de la fuente se registran claramente para asegurar la calidad del comercio.",
  rules71: "Recomendaciones de selección",
  rules72:
    "Hay una tendencia a la baja en los precios de los bienes, y se recomienda elegir cuando el presupuesto es limitado.",
  rules73:
    "Ahorre tarifas de servicio y controle con precisión los precios de mercado de los bienes y elija sugerencias para comprar bienes a largo plazo.",
  rules74:
    "Las fuentes son de buena calidad y los precios de mercado son estables o están en aumento. Los propietarios no tienen claro el valor de la fuente y quieren vender a un precio más alto.",
  rules75:
    "Ahorre tarifas de servicio y el precio tiene opciones recomendadas con expectativas psicológicas claras.",
  rules76: "Capítulo 3 entrega física",
  rules77: "Artículo 14",
  rules78:
    "Después del éxito de la transacción central, el comprador y el vendedor manejan la salida del objeto, el cambio de capital y la entrega.",
  rules79: "Artículo 15",
  rules80:
    "Acuerdo de cumplimiento: después de la conclusión de la transacción, cualquiera de los clientes del comprador y vendedor ha violado el contrato (sujeto a retención de margen). Además de cumplir con el proceso de demanda de invitado y retención de margen, este cliente también se incluirá en la lista negra de clientes del centro de comercio, lo que afectará o limitará la participación en transacciones posteriores.",
  rules81: "Capítulo IV Disposiciones complementarias",
  rules82: "Artículo 16",
  rules83:
    "El derecho a interpretar y establecer estas reglas es propiedad de global bulk water products trading platform.",
  rules84: "Artículo 17",
  rules85:
    "La plataforma global de negociación de productos de agua a granel tiene el derecho de revisar y ajustar las reglas de margen de acuerdo con las necesidades de la plataforma de negociación. Las reglas revisadas serán notificadas a los usuarios por medios apropiados, como cartas en la estación y anuncios públicos en el sitio web. Si el usuario continúa utilizando la plataforma de negociación después de la revisión de las reglas de margen y realiza un depósito, se considera que el usuario ha entendido y aceptado completamente las reglas de margen revisadas y acepta que la plataforma de negociación gestiona el depósito pagado por el usuario de acuerdo con las reglas revisadas.",
  rules86: "Artículo 18",
  rules87:
    "Las partes en una disputa que surja del presente reglamento se resolverán de forma amistosa mediante negociaciones. Si las negociaciones no pueden resolverse, todas las partes acuerdan someter el asunto en disputa al departamento de arbitraje pertinente, que será arbitrado de acuerdo con el reglamento de arbitraje vigente en el tribunal en el momento de la solicitud de arbitraje. El laudo arbitral es definitivo y vinculante para todas las partes.",
  rules88: "Artículo 19",
  rules89:
    "Las leyes de China continental se aplicarán a la interpretación y ejecución de estas reglas. Cualquier disposición de estas reglas que se considere inválida no afectará la validez de las demás disposiciones.",
  rules90: "Artículo 20",
  rules91: "El presente reglamento entrará en vigor el día de su publicación.",
  contact1: "Teléfono: 400 - 101 - 2799",
  contact2: "Buzón: mail@huacaizhaoyu.com",
  contact3:
    "Dirección: 601a, bloque e1, parque de la sede del siglo huateng, patio 9 de chenjialin, balizhuang, Distrito de chaoyang, Beijing",
  contact4: "Barrer",
  contact5: "Ver applets",
  contact6: "Atención",
  contact7: "Cuenta pública de Wechat",
  indexnew1:
    "Crear una plataforma global de comercio en línea de productos acuáticos de alta gama",
  indexnew2:
    "Aprobado por el gobierno de shenzhen, patrocinado conjuntamente por China agricultural development group y shenzhen port group, con el apoyo técnico de beijing huachai. Como base nacional de pesca pelágica de shenzhen proyecto piloto puesto en operación.",
  indexnew3: "Sistema de precios de calificación estandarizado",
  indexnew4: "Equipo profesional del control de calidad",
  indexnew5: "La tecnología AI",
  indexnew6: "Rastrearlos",
  indexnew7: "Sistema de cierre",
  indexnew8: "Red de posiciones cerradas",
  indexnew9: "Sistema de crédito",
  indexnew10: "Valoración de clientes",
  indexnew11: "Garantía de plataforma",
  delivery1:
    "Plataforma global de negociación de productos de agua a granel cierre global de posiciones",
  delivery2: "Entrega globalizada de atún en el centro comercial",
  delivery3:
    "Los depósitos de entrega globales incluyen depósitos propios de trading center y construidos con socios nacionales e internacionales. Cubren ciudades y puertos importantes en las principales regiones productoras y consumidoras de atún.",
  delivery4: "Internacionalización, normalización, especialización, branding",
  delivery5:
    "La construcción y el desarrollo de un almacén de cierre global proporciona un servicio de cierre más conveniente, eficiente, seguro y confiable para el atún de la CTC y amplía la influencia y visibilidad internacional de la CTC.",
  delivery6:
    "Fortalecer la cooperación con socios nacionales e internacionales",
  delivery7:
    "Trading central continuará fortaleciendo su colaboración con socios nacionales e internacionales para ampliar su red y cobertura de posiciones cerradas en todo el mundo.",
  delivery8: "Cobertura de las principales ciudades de distribución costera",
  delivery9:
    "Cubriendo las principales ciudades de distribución costera nacional: dalian, qingdao, zhoushan, fuzhou, shenzhen, kaohsiung, etc.; Cobertura de China y asia oriental: tokio, busan, bangkok, etc.;",
  delivery10:
    "El almacén de entrega global de shenzhen international tuna trade center se refiere a la red de almacenes de entrega establecidos por trade center en todo el mundo, con el objetivo de proporcionar un servicio de entrega global para el atún de trade center. Los depósitos de entrega globales incluyen depósitos propios de trading center y construidos con socios nacionales e internacionales. Cubren ciudades y puertos importantes en las principales regiones productoras y consumidoras de atún.",
  delivery11:
    "La construcción y desarrollo de posiciones de cierre globales es una parte importante de la estrategia de desarrollo de trading center para lograr la internacionalización, normalización, especialización y marca. La construcción y el desarrollo de un almacén de cierre global puede proporcionar un servicio de cierre más conveniente, eficiente, seguro y confiable para el atún de la CTC y ampliar la influencia internacional y la visibilidad de la CTC.",
  delivery12:
    "En la actualidad, el centro de comercio ha establecido relaciones de cooperación intencionales con varias empresas e instituciones líderes de la industria en las principales ciudades de distribución costera del país. En el futuro, trading central continuará fortaleciendo su cooperación con socios nacionales y extranjeros para ampliar la red y cobertura de posiciones cerradas en todo el mundo, mejorar la calidad y la eficiencia de los servicios de cierre, y proporcionar a los clientes un mejor servicio y un método de cierre más conveniente.",
  delivery13:
    "Plan de desarrollo de la construcción de la fase de red de cierre:",
  delivery14:
    "Fase 1: cubriendo las principales ciudades de distribución costera nacional: dalian, qingdao, zhoushan, fuzhou, shenzhen, kaohsiung, etc.;",
  delivery15:
    "Fase 2: cubriendo China y asia oriental: tokio, busan, bangkok, etc.;",
  delivery16:
    "Fase 3: cubriendo las principales ciudades de distribución de los países de la bri.",
  rksj: "Tiempo de almacenamiento",
  szjg: "Precio en shenzhen",
  nian: "en",
  yue: "de",
  zajzzz: "Cargando en",
  flllll: "Clasificación",
  xia: "Camarón rojo argentino",
  xue: "Bacalao",

  zhgll: "Asociación de cuenta",
  ztzh1: "Número de cuenta principal",
  dqdlzh1: "(cuenta actualmente conectada)",
  yglfh1: "Número secundario ya asociado",
  xz1: "nuevos",
  bzmc1: "Observaciones nombre nombre",
  cz1: "La operación",
  tjxgbz: "Añadir/modificar comentarios",
  dqzhybgl: "La cuenta actual ya está asociada",
  ryywqlx: "Si tiene preguntas, póngase en contacto con",

  glzh1: "Una cuenta asociada",
  qsrxygldsjh: "Por favor, introduzca el número de teléfono que desea asociar",
  qsrbz1: "Por favor, introduzca una nota (ocho palabras o menos)",
  dqgldsjh1: "Número de teléfono móvil actualmente asociado",
  glcg: "Asociado al éxito",
  cczjyjscsfjx: "Esta acción se eliminará permanentemente. ¿Desea continuar?",
  tss1: "Sugerencia"
};



// WEBPACK FOOTER //
// ./src/lang/sp.js